/**
 * Other selectors
 */

import { RestoreFormData } from './model';

export const createInitialValues = (): RestoreFormData => ({
    restoreSnapshotId: undefined,
});
